// Human-traffic beacon (log-based).
//
// The server request log is dominated by bots (scanners that spoof referrers
// and even run JS), so it can't tell us how many real humans arrive. This
// fires a single beacon per session, but ONLY after the first genuine
// interaction (scroll / pointer / key / touch) — headless scanners almost
// never generate those, so it counts humans, not bots.
//
// It's a plain tracking pixel: a GET to the static /hb.gif with the visitor id
// and referrer in the query string. nginx serves the pixel and logs the full
// request line (path + query) in its access log — no backend, no DB, no
// endpoint. Count humans with:
//   grep '/hb.gif?v=' access.log        → all human beacons
//   ... | grep -oP 'v=\K[^&]+' | sort -u | wc -l   → unique humans
//   ... | grep -oP 'r=\K[^&]+'          → referrers (channel)
// visitor_id is a client UUID (localStorage): unique humans without any IP.

const VISITOR_KEY = "tactics_vid";
const SENT_KEY = "tactics_beacon_sent"; // per-session guard (sessionStorage)
const EVENTS = ["pointerdown", "keydown", "scroll", "touchstart"];

function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id =
        (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
        `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return `anon-${Date.now()}`; // private mode / storage blocked
  }
}

export function initHumanBeacon() {
  try {
    if (sessionStorage.getItem(SENT_KEY)) return; // already counted this session
  } catch {
    /* storage blocked — fall through, worst case once per load */
  }

  let sent = false;
  const cleanup = () => EVENTS.forEach((e) => window.removeEventListener(e, fire));

  function fire() {
    if (sent) return;
    sent = true;
    cleanup();
    try {
      sessionStorage.setItem(SENT_KEY, "1");
    } catch {
      /* ignore */
    }

    const params = new URLSearchParams({
      v: getVisitorId(),
      r: document.referrer || "",
      p: window.location.pathname,
      t: String(Date.now()), // cache-buster so every hit reaches the server
    });
    // Tracking pixel: a GET the server logs. Image() needs no CORS/fetch and
    // never throws into the app.
    try {
      const img = new Image();
      img.src = `/hb.gif?${params.toString()}`;
    } catch {
      /* analytics must never break the app */
    }
  }

  EVENTS.forEach((e) => window.addEventListener(e, fire, { passive: true }));
}
